<template>
  <svg class="svg-inline--fa fa-w-16">
    <use :xlink:href="iconURL" />
  </svg>
</template>

<script>
import sprites from '@images/fontawesome/sprites.svg'
export default {
  props: {
    type: { type: String, required: true },
    icon: { type: String, required: true }
  },
  computed: {
    iconURL() {
      return sprites + `#${this.type}-fa-${this.icon}`
    }
  }
}
</script>
